import React, { Component } from "react";
import service from '../services';
import ReactPaginate from "react-paginate";
import Loader from "../component/loader";

import Cookies from 'universal-cookie';

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
import CopyToClipboard from "copy-to-clipboard";
// Images import
import serachIcon from "../assets/images/search.svg";
import cloud from "../assets/images/cloud.svg";
import { Link } from "react-router-dom";
import moment from 'moment'
import SIOuserModal from './CreateSIOuser';
import PressuserModal from './CreatePressuser';
import CreateCircleuser from './CreateCircleuser';
import CreateGeneraluser from './CreateGeneralUser';
import CheckBox from './CheckBox';

import ReceiptModal from './ReceiptModal';
import ManageMembershipModel from './ManageMembershipModel';

import EditIcon from '../icons/EditIcon';
import LockIcon from '../icons/LockIcon';
import LockCloseIcon from '../icons/LockCloseIcon';


import DeleteIcon from '../icons/DeleteIcon';
import ShareIcon from '../icons/ShareIcon';
import ModalMessage from './../component/ModalMessage';
//sweet alert
import swal from 'sweetalert';
import ErrorPopUp from "./errorPopUp";
import commonImage from "../commonImage";
import PlusIcon from "../icons/plusicon";
import SearchUserModal from './../component/SearchUserModal'
import CsvUploadModal from './../component/CsvUploadModal'
import { STORAGE_PATHS } from "../cosntants";

const mapStateToProps = state => ({
    getLoginRole: state.getLoginRole,
    getLoginUser: state.getLoginUser,
    profileName: state.profileName,
    allInitial: state.allInitial
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

const cookies = new Cookies();


let sub;
let purchaseFilterArray = [];
let accessTypeArray = [];
let discountTypeArray = [];
let approveStatus = [];
let url = process.env.REACT_APP_FRONTEND_ORIGIN_SIO

class AdminDashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorPopup: false,
            isCompChecked: false,
            fileUploading: false,
            uploadCSVModal: false,
            userForApprove: [],
            createuSIOser: false,
            createPressuser: false,
            createCircleuser: false,
            createGeneraluser: false,
            checkApprove: false,
            checkUnApprove: false,
            successmodal: false,
            purchasereceipt: false,
            comp: false,
            comp50: false,
            comp250: false,
            comp350: false,
            comp100: false,
            lateReg: false,
            sioComp:false,
            sioComp100:false,
            sioComp250:false,
            sio350:false,
            sioEarlyIndustry:false,
            sioEarlyExpress:false,
            users: [],
            emailLoader: false,
            resendMailPopup: false,
            MailSendPopup: false,
            AddRemove: false,
            userForResendMail: [],
            offset: 0,
            perPage: 50,
            currentPage: 1,
            searchField: '',
            copyLink: '',
            messageModal: false,
            displayPass: "",
            deviceModel: false,
            currentUserID: '',
            deviceId: '',
            purchaseList: [],
            copylinkflag: false,
            copyiconflag: false,
            mailLink: '',
            loginLink: '',
            mailstatus: "",
            totalAddedRecord: 0,
            totalSkippedRecord: 0,
            membership: false,
            MailSendPopup: false,
            skippedUser: [],
            purchase: [
                { assign: "Purchased", name: "complete", value: false },
                { assign: " Purchase Pending", name: "pending", value: false },
            ],
            approvePass: [
                { assign: "Approved", list: "approved", value: false },
                { assign: "Pending", list: "pending", value: false },
            ],
            accessPass: [],
            // accessPass:[
            //     {assign:"Purchased", name:"complete",value:false},
            //     {assign:" Purchase Pending", name:"pending",value:false},
            // ]
            discount:[],
            defaultUser: {},
            isSync: false,
            syncId: null,
            syncMessageModal:{
                flag: false,
                message: ""
            },
            clickUserMembership: {},
            typing: false,
            typingTimeout: 0,
            loaderFlagData:false,
            isValidCode:true,
            membershipLevel:[],
            userHistoryModal: false,
            selectedHistoryUser: null,
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        purchaseFilterArray = [];
        accessTypeArray = [];
        discountTypeArray = [];
        approveStatus = [];
    }

    componentDidMount() {
        if(this.props?.getLoginRole?.user?.role === 'admin'){ 
            this.props.history.push('/access-management')
        }
        
        let currentPage = localStorage.getItem('currentPage')
        if (currentPage) {
            this.setState(
                {
                    offset: parseInt(localStorage.getItem("offset")),
                    perPage: parseInt(localStorage.getItem("perPage")),
                    currentPage: parseInt(localStorage.getItem("currentPage")),
                },
                () =>
                    this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                        this.getGeneralList(this.state.offset, this.state.perPage) :
                        this.getEventList(this.state.offset, this.state.perPage,purchaseFilterArray, discountTypeArray,accessTypeArray,approveStatus)
            );
            localStorage.removeItem("offset");
            localStorage.removeItem("perPage");
            localStorage.removeItem("currentPage");
        } else {
            this.setState({
                offset: 0,
                perPage: 50,
                currentPage: 0
            },
                () =>
                    this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                        this.getGeneralList(this.state.offset, this.state.perPage) :
                        this.getEventList(this.state.offset, this.state.perPage,purchaseFilterArray, discountTypeArray,accessTypeArray,approveStatus))
        }
        if (this.props.allInitial) {
            this.setInitialDataFromProps(this.props.allInitial);
        }
        this.apiserve.sendevent("cart-purchase|getDate", {});
        this.apiserve.sendevent("admin|getCouponList", {});
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getAllUser":
                    this.setState({
                        users: response.data.docs,
                        getTotalDocs: response.data.totalDocs,
                        pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                    }, () => {
                        this.setState({ loaderFlagData: false,loaderFlag:false })
                    })
                    break;
                case "generalUser|getAllUser":
                    this.setState({
                        users: response.data.docs,
                        getTotalDocs: response.data.totalDocs,
                        pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                    }, () => {
                        this.setState({ loaderFlag: false , loaderFlagData:false})
                    })
                    break;
                case "email|send":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            MailSendPopup: false,
                            emailLoader: false,
                            userForResendMail: []
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "generalUser|generalUser_email_send":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            MailSendPopup: false,
                            emailLoader: false,
                            MailSendPopup: false,
                            userForResendMail: []
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "user|syncLibrary" : 
                    if(!response.error && response.data.success){
                        this.setState({
                            syncMessageModal:{
                                flag: true,
                                message: " Synchronization Successfully!"},
                        }, () => {
                            this.setState({ 
                                isSync:  false
                            })
                        })
                    }
                break;     
                case "admin|blockUser":
                    this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                        this.getGeneralList(this.state.offset, this.state.perPage) :
                        this.getEventList(this.state.offset, this.state.perPage);
                    break;
                case "admin|removeUser":
                    if (!response.error) {
                        swal("Your record has been deleted!", {
                            icon: "success"
                        }).then((success) => {
                            this.apiserve.success('User deleted successfully')
                            this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                                this.getGeneralList(this.state.offset, this.state.perPage) :
                                this.getEventList(this.state.offset, this.state.perPage);
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|removeRoleUser":
                    if (!response.error) {
                        swal("User role has been removed !", {
                            icon: "success"
                        }).then((success) => {
                            if (success) {
                            }
                            this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                                this.getGeneralList(this.state.offset, this.state.perPage) :
                                this.getEventList(this.state.offset, this.state.perPage);
                        });
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|importCsv":

                    if (!response.error) {
                        this.setState({
                            fileUploading: false,
                            totalAddedRecord: response.data.totalProcessedRecord,
                            totalSkippedRecord: response.data.totalSkippedRecord,
                            skippedUser: response.data.skipUserArray,
                            message: response.data.message,
                            totalUpdatedRecord : response.data.totalUpdatedRecord 
                        }, () => {
                            this.setState({
                                uploadCSVModal: true
                            })
                        })
                        this.getEventList(this.state.offset, this.state.perPage);
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "generalUser|importCsv":
                    if (!response.error) {
                        this.setState({
                            fileUploadingGeneral: false,
                            totalAddedRecord: response.data.totalAddedRecord,
                            totalSkippedRecord: response.data.totalSkippedRecord,
                            skippedUser: response.data.skippedUser,
                            message: response?.data?.message,
                            totalUpdatedRecord : response?.data?.totalUpdatedRecord 
                        }, () => {
                            this.setState({
                                uploadCSVModal: true
                            })
                        })
                        this.getEventList(this.state.offset, this.state.perPage);
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|getUserCsv":
                    if (!response.error) {
                        window.open(response.data.location)
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;

                case "admin|confirmUser":
                    if (!response.error) {
                        this.setState({
                            isPendingApproval: false,
                            checkApprove: false,
                            checkUnApprove: false,
                            userForApprove: []
                        })
                        this.getEventList(this.state.offset, this.state.perPage);
                    }
                    else {
                        this.setState({
                            isPendingApproval: false,
                        })
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|unapprovePass":
                    if (!response.error) {
                        this.setState({
                            checkUnApprove: false,
                            isPendingApproval: false,
                            checkApprove:false,
                        })
                        this.getEventList(this.state.offset, this.state.perPage);
                    }
                    else {
                        this.setState({isPendingApproval: false,checkApprove:false})
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|getReferralLink":
                    if (!response.error) {
                        this.setState({
                            copyLink: response.data.link
                        })
                    }
                    break;
                case "admin|getPasses":
                    if (!response.error) {
                        this.setState({
                            allPasses:response.data
                        })
                        var list = response.data.find((_) => _.identifier === this.state.userForApprove.passType);
                        if (list) {
                            let newPrice = list.price
                            if(this.state.userForApprove.appliedDiscountCode !== null && this.state.userForApprove.appliedDiscountCode !== undefined){
                                let discount = this.state.discount.find(item => item._id === this.state.userForApprove?.appliedDiscountCode?._id)
                                if(discount?.discount?.type === 'percentage'){
                                    list.discountPrice = newPrice - (newPrice * discount.discount.off / 100)
                                } else {
                                    list.discountPrice = newPrice - discount.discount.off
                                }
                            } else {
                                list.discountPrice = ''
                            }
                        }
                        var accessPass = []

                        response.data.map(item => {
                            if(accessTypeArray.length > 0){
                                accessTypeArray.map(pass => {
                                    if(pass === item.identifier){
                                        item.value = true
                                    }
                                })
                            }
                        })
                        if (this.props.getLoginRole && this.props.getLoginRole.user && (this.props.getLoginRole.user.role === 'sio')) {
                            
                            accessPass = [...response.data]
                        } else {
                            accessPass = [...response.data]
                        }
                        console.log(accessPass,"passss", list);
                        this.setState({
                            displayPass: list,
                            accessPass: accessPass
                        });
                        if (this.props.getLoginRole && this.props.getLoginRole.user && (this.props.getLoginRole.user.role === 'sundanceGuest')) {
                            this.setState({
                                accessPass: this.state.accessPass.filter(function (el) { return el.name != "Standard Pass"; })
                            })
                        }
                    }
                    break;
                case "loginUser":
                    if (!response.error) {
                        if(cookies.get(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : 'myEventiveLoginToken')){
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : "myEventiveLoginToken", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            window.Eventive.logout()
                        }
                        let data = {
                            fname: response.data.userData.fname,
                            lname: response.data.userData.lname,
                            image: response.data.userData.image,
                            showMyLibrary: response.data.showMyLibrary || false,
                            userRole:response.data.userData.additionalRoles,
                            userId: response.data.user._id,
                            token: response.data.token,
                            email: response.data.email,
                            userRoleFormatted: this.getRoleString(response.data.user.additionalRoles)
                        }
                        document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                        cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                        cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "STYXKEY_sundanceUser" : "STYXKEY_sundanceUser", data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/", secure: true })
                        if(this.props.getLoginRole && this.props.getLoginRole.user && (this.props.getLoginRole.user.role === 'sio')){
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_SIO)
                        } else {
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_GENERAL)
                        }
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break
                case "generalUser|generalUserGostLogin":
                    if (!response.error) {
                        if(cookies.get(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : 'myEventiveLoginToken')){
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : "myEventiveLoginToken", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            window.Eventive.logout()
                        }
                        if (!response && response.data && response.data.user && (response.data.user.role === 'sioUser' || response.data.user.role === 'pressUser' || response.data.user.role === "circleGuestUser" || response.data.user.role === "artistUser")) {
                            let data = {
                                fname: response.data.userData.fname,
                                lname: response.data.userData.lname,
                                image: response.data.userData.image,
                                showMyLibrary: response.data.showMyLibrary || false,
                                userRole:response.data.userData.additionalRoles,
                                userId: response.data.user._id,
                                token: response.data.token,
                                userRoleFormatted: this.getRoleString(response.data.user.additionalRoles)
                            }
                            document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/",secure:true })
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_GENERAL)
                        } else {
                            let data = {
                                fname: response.data.userData.fname,
                                lname: response.data.userData.lname,
                                image: response.data.userData.image,
                                showMyLibrary: response.data.showMyLibrary || false,
                                userRole:response.data.userData.additionalRoles,
                                userId: response.data.user._id,
                                token: response.data.token,
                                email: response.data.email,
                                userRoleFormatted: this.getRoleString(response.data.userData.additionalRoles)
                            }
                            document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/",secure:true })
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_GENERAL)
                        }
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "admin|getUserDeviceId":

                    this.setState({
                        getdeviceCode: response.data,
                        date: response.data.date,
                        deviceId: response.data.deviceId !== '' ? response.data.deviceId : '',
                        _id: response.data._id
                    })

                    break;
                case "admin|removeUserDeviceId":
                    if (response.error) {
                        this.apiserve.error(response.data.error)
                    } else {
                        this.setState({
                            deviceModel: false,
                        }, () => this.apiserve.success("Delete device Id"))
                    }
                    break;
                case "admin|getPurchaseHistory":
                    if (!response.error) {
                        this.setState({
                            purchasereceipt: true,
                            purchaseList: response.data.orders
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "email|sendLinkToPrompt":
                    if (!response.error) {
                        this.setState({
                            resendMailPopup: true,
                            mailLink: response ?.data ?.mailLink ?.registerRef,
                            loginLink: response ?.data ?.mailLink ?.loginLink,
                        })
                    }
                    break;
                case 'stripeProduct|isValidCouponCode':
                    if(!response.error){
                        this.setState({isValidCode:response.data.isValidCode})
                    }
                    break;
                case 'admin|getCouponList':
                    if(!response.error){
                        let data = response.data.map(item => ({
                            ...item,
                            value: false
                        }))
                        this.setState({discount:[...data,{ '_id':'N/A',couponCode: 'None', identifier: 'N/A',checkLable: 'lnone', value: false }]})
                    }
                    break;
                case 'user|sff|getAllInitialForRedis':
                    if(!response.error){
                        this.setState({membershipLevel:Object.entries(response.data.membership.levels).map(([key, value]) => ({ 'name':value,'_id':key }))})
                    }
                    break;
                default:
                    break;
            }
        })
    }



    componentDidUpdate(prevProps) {
        if (prevProps.allInitial !== this.props.allInitial) {
            this.setInitialDataFromProps(this.props.allInitial);
        }
    }

    setInitialDataFromProps = (allInitial) => {
        if (allInitial && allInitial.membership && allInitial.membership.levels) {
            this.setState({
                membershipLevel: Object.entries(allInitial.membership.levels).map(([key, value]) => ({ 'name': value, '_id': key }))
            })
        }
    }

    getRoleString = (roles) => {
        const roleMap = {
            generalUser: 'General',
            circleGuestUser: 'Sundance Guest',
            sundanceGuestUser: 'Sundance Guest',
            sioUser: 'Industry',
            pressUser: 'Press',
            circleUser: 'Sundance Circle',
            artistUser: 'Artist',
            pafUser: 'PAF User'
        };
        return roles.length > 1 ? roles.map(role => roleMap[role] || '').filter(Boolean).join(' & ') : roleMap[roles[0]] || '';
    };

    getEventList = (skip, limit, purchaseFilterArray, discountTypeArray,accessTypeArray,approveStatus) => {
        var data = {
            page: skip,
            limit: limit
        }
        if (this.state.searchField?.length) {
            data.filter = this.state.searchField
        }
        if (purchaseFilterArray && purchaseFilterArray.length) {
            data.purchaseStatus = purchaseFilterArray
        }
        if (accessTypeArray && accessTypeArray.length) {
            data.passType = accessTypeArray
        }
        if (discountTypeArray && discountTypeArray.length) {
            data.discount = discountTypeArray
        }
        if (approveStatus && approveStatus.length) {
            data.status = approveStatus
        }
        // data.page = skip
        // data.limit= limit
        this.setState({loaderFlagData:true})
        this.apiserve.sendevent("admin|getAllUser", data);
        this.apiserve.sendevent("admin|getReferralLink", {});
        this.apiserve.sendevent("admin|getPasses", {});
    }

    getGeneralList = (skip, limit) => {
        var data = {}
        data = {
            page: skip,
            limit: limit,
        }
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        this.setState({loaderFlagData:true})
        this.apiserve.sendevent("generalUser|getAllUser", data);
    }

    getRole = (ROLE) => {
        switch (ROLE) {
            case 'sio':
                return 'createSIOuser'
            case 'press':
            case 'artist':
                return 'createPressuser'
            case 'general':
                return 'createGeneraluser'
            case 'sundanceGuest':
                return 'createCircleuser'
            default:
                break;
        }
    };

    CreateNewUser = (Email) => { this.setState({ searchUser: false, defaultEmail: Email, [this.getRole(this.props.getLoginRole.user.role)]: true }) };

    searchUsers = () => { this.setState({ [this.props.getLoginRole.user.role === 'general' ? 'createGeneraluser' : 'searchUser']: true }) };

    SelectUser = (UserId) => {
        this.setState({ searchUser: false })
        this.editUser(UserId, true)
    }

    CloseModal = () => {
        if (this.state.createSIOuser === true || this.state.createPressuser === true || this.state.createCircleuser === true || this.state.createGeneraluser === true || this.state.checkApprove === true || this.state.checkUnApprove === true || this.state.successmodal === true || this.state.purchasereceipt === true || this.state.searchUser === true || this.state.uploadCSVModal === true) {
            this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                this.getGeneralList(this.state.offset, this.state.perPage) :
                this.getEventList(this.state.offset, this.state.perPage,purchaseFilterArray, discountTypeArray,accessTypeArray,approveStatus);
        }
        this.setState({
            createSIOuser: false,
            createPressuser: false,
            createCircleuser: false,
            createGeneraluser: false,
            checkApprove: false,
            checkUnApprove: false,
            successmodal: false,
            resendMailPopup: false,
            purchasereceipt: false,
            searchUser: false,
            defaultEmail: '',
            uploadCSVModal: false,
            AddRemove: false,
            membership: false,
            MailSendPopup: false,
            copylinkflag: false,
            isValidCode:true
        })
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal: false
        })
    }

    openUserHistory = (user) => {
        this.setState({ userHistoryModal: true, selectedHistoryUser: user });
    }

    closeUserHistoryModal = () => {
        this.setState({ userHistoryModal: false, selectedHistoryUser: null });
    }

    CloseSyncMessageModal = () => {
        this.setState({
            syncMessageModal:{
                flag: false,
                message: ""},
        });
    };

    ApproveCheck = () => {
        this.setState({
            checkApprove: true
        })
    }

    sendEmailPopup = (user) => {
        let data = {
            userId: user._id
        }
        const Role = this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role

        if (user.status === "invited") {
            this.apiserve.sendevent("email|sendLinkToPrompt", data);
        } else if (Role === 'general') {
            this.apiserve.sendevent("generalUser|generalUser_email_send", data)
        } else {
            this.setState({
                MailSendPopup: true
            })
        }


        this.setState({
            userForResendMail: user
        })
    }




    resendMail = () => {
        const Role = this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role

        var data = {
            userId: this.state.userForResendMail._id
        }
        this.setState({
            emailLoader: true
        })

        if (Role && Role === 'general') {
            this.apiserve.sendevent("generalUser|generalUser_email_send", data)
        }
        else {
            this.apiserve.sendevent("email|send", data)
        }
    }

    approveUserPopup = (user) => {
        this.apiserve.sendevent("admin|getPasses", {});
        this.setState({
            userForApprove: user
        }, () => {
            if(user.appliedDiscountCode !== null){
                this.checkDiscount(user.appliedDiscountCode?.identifier)
            }
            this.setState({
                checkApprove: true
            })
        })

    }
    unapproveUserPopup = (user) => {
        this.apiserve.sendevent("admin|getPasses", {});
        this.setState({
            userForApprove: user
        }, () => {
            if(this.props.getLoginRole.user.role === 'sio'){
                this.setState({
                    checkUnApprove: true
                })
            } else {
                this.setState({
                    checkUnApprove: true
                })
            }
        })

    }

    UnApproveYes = (e,type) => {
        const { userForApprove} = this.state;
        this.setState({ isPendingApproval: type === 'Yes' ? true : false })
        var data = { 
            userId: userForApprove._id, 
        }
        this.apiserve.sendevent("admin|unapprovePass", data);
    }
    ApproveYes = () => {
        const { userForApprove } = this.state;
        this.setState({ isPendingApproval: true })
        var data = { 
            userId: userForApprove._id, 
            appliedDiscountCode:userForApprove.appliedDiscountCode
        }
        console.log(data,"data");
        this.apiserve.sendevent("admin|confirmUser", data);
    }
    checkDiscount = (comp) => {
        this.apiserve.sendevent('stripeProduct|isValidCouponCode',{"code":comp})
    }

    makeItComp = (e) => {
        const { name, checked, id } = e.target;
        this.setState({isValidCode:true})
        let newId = id.substr(2, id.length)
        let discount = this.state.discount.find(item => item._id === newId)
        if(checked){
            this.checkDiscount(discount?.identifier)
        }
        if (checked) {
            this.setState({
                userForApprove: {...this.state.userForApprove, appliedDiscountCode: {_id: discount._id, identifier: discount.identifier}},
            })
            if(discount.discount.type === 'percentage'){
                this.state.displayPass.discountPrice = this.state.displayPass.price - (this.state.displayPass.price * discount.discount.off / 100)
            } else {
                this.state.displayPass.discountPrice = this.state.displayPass.price - discount.discount.off
            }
        } else {
            this.state.displayPass.discountPrice = ''
        }
    }

    handelDeviceModel = (userId) => {
        this.setState({
            deviceModel: true,
            currentUserID: userId,
        })
        this.apiserve.sendevent("admin|getUserDeviceId", { userId: userId })
    }

    purchaseReceipt = (eventiveId) => {
        this.setState({ currentEventiveId: eventiveId })
        this.apiserve.sendevent("admin|getPurchaseHistory", { userEventiveId: eventiveId })
    }

    manageMembershipModel = (userDetail) => {
        this.setState({
            membership: !this.state.membership,
            clickUserMembership: userDetail
        })
    }

    closedeviceModel = () => {
        this.setState({
            deviceModel: false
        })
    }

    handelDeviceremove = (Id) => {
        if (Id) {
            this.apiserve.sendevent("admin|removeUserDeviceId", { userId: Id })
        } else {
            this.setState({
                deviceModel: false
            })
        }
    }

    getDisplayValue = (accNo) => {
        const { profileName } = this.props;
        let accessValue = profileName.CMA.find(_ => _.access === accNo);
        return accessValue ? accessValue.value : false;
    }

    getUserData = () => {
        var self = this;
        const { profileName } = this.props
        const {isSync,syncId, accessPass, allPasses} = this.state;
        return this.state.users && this.state.users.length > 0 && this.state.users.map(function (user, index) {
            let purchasedAt = `${moment(self.props.getLoginRole.user.role === 'press' ? user?.presspurchasedAt : user.purchasedAt).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(self.props.getLoginRole.user.role === 'press' ? user?.presspurchasedAt : user.purchasedAt).tz("US/Mountain").format('h:mm A')}`;
            let registrationCompleteDate = `${moment(user.registrationCompleteDate).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(user.registrationCompleteDate).tz("US/Mountain").format('h:mm A')}`;
            let lastLogin = `${moment(user.lastLogin).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(user.lastLogin).tz("US/Mountain").format('h:mm A')}`;
            let createdAt = `${moment(user.createdAt).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(user.createdAt).tz("US/Mountain").format('h:mm A')}`;
            return (
                <tr>
                    <td className="user_email_d">
                        <span className="user_status">
                            {user && (self.props.getLoginRole.user.role === 'press' ? user.pressPurchaseStatus :  user.purchaseStatus) === 'complete' ?
                                <svg className='active' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5H0ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.711V10.71Z" fill="black" />
                                </svg>
                                :
                                <svg className='active' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.41319 0.104126C9.46181 0.104126 11.2095 0.827506 12.6562 2.27427C14.103 3.72102 14.8264 5.46292 14.8264 7.49996C14.8264 9.537 14.103 11.2789 12.6562 12.7257C11.2095 14.1724 9.46181 14.8958 7.41319 14.8958C5.36458 14.8958 3.6169 14.1724 2.17014 12.7257C0.72338 11.2789 0 9.537 0 7.49996C0 5.46292 0.72338 3.72102 2.17014 2.27427C3.6169 0.827506 5.36458 0.104126 7.41319 0.104126ZM8.15972 11.2152V9.72218H6.66667V11.2152H8.15972ZM8.15972 8.22913V3.78468H6.66667V8.22913H8.15972Z" fill="#FF8311" />
                                </svg>
                            }
                        </span>
                        {/* } */}
                        {user.email}</td>
                    <td className="user_firstName_d">{user.fname}</td>
                    <td className="user_lastName_d">{user.lname}</td>
                    <td className="user_company_d">{user.companyName}</td>
                    {self.props.getLoginRole && self.props.getLoginRole.user && (self.props.getLoginRole.user.role === 'general' || self.props.getLoginRole.user.role === 'sundanceGuest') ? '' :
                        <td className="user_pass">
                            {self.props.getLoginRole.user.role === 'press' ? 
                            allPasses?.filter(_ => _.identifier === user.pressPassType).length > 0 ? allPasses?.filter(_ => _.identifier === user.pressPassType)[0].name : '' :
                            allPasses?.filter(_ => _.identifier === user.passType).length > 0 ? allPasses?.filter(_ => _.identifier === user.passType)[0].name : ''}
                            {
                                user.comp ?
                                    <span className="freepass_icon">
                                        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.75 4.6667L5.67625 0.913369C5.77211 0.840277 5.88476 0.80127 6 0.80127C6.11524 0.80127 6.22789 0.840277 6.32375 0.913369L11.25 4.6667V14C11.25 14.1768 11.1885 14.3464 11.0791 14.4714C10.9697 14.5965 10.8214 14.6667 10.6667 14.6667H1.33333C1.17862 14.6667 1.03025 14.5965 0.920854 14.4714C0.811458 14.3464 0.75 14.1768 0.75 14V4.6667ZM6 7.33337C6.30942 7.33337 6.60616 7.19289 6.82496 6.94285C7.04375 6.6928 7.16667 6.35366 7.16667 6.00004C7.16667 5.64641 7.04375 5.30728 6.82496 5.05723C6.60616 4.80718 6.30942 4.6667 6 4.6667C5.69058 4.6667 5.39383 4.80718 5.17504 5.05723C4.95625 5.30728 4.83333 5.64641 4.83333 6.00004C4.83333 6.35366 4.95625 6.6928 5.17504 6.94285C5.39383 7.19289 5.69058 7.33337 6 7.33337Z" fill="#00AA11" />
                                        </svg>
                                    </span> :
                                    user.comp50 ?
                                        <span className="freepass_icon">
                                            <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.75 4.6667L5.67625 0.913369C5.77211 0.840277 5.88476 0.80127 6 0.80127C6.11524 0.80127 6.22789 0.840277 6.32375 0.913369L11.25 4.6667V14C11.25 14.1768 11.1885 14.3464 11.0791 14.4714C10.9697 14.5965 10.8214 14.6667 10.6667 14.6667H1.33333C1.17862 14.6667 1.03025 14.5965 0.920854 14.4714C0.811458 14.3464 0.75 14.1768 0.75 14V4.6667ZM6 7.33337C6.30942 7.33337 6.60616 7.19289 6.82496 6.94285C7.04375 6.6928 7.16667 6.35366 7.16667 6.00004C7.16667 5.64641 7.04375 5.30728 6.82496 5.05723C6.60616 4.80718 6.30942 4.6667 6 4.6667C5.69058 4.6667 5.39383 4.80718 5.17504 5.05723C4.95625 5.30728 4.83333 5.64641 4.83333 6.00004C4.83333 6.35366 4.95625 6.6928 5.17504 6.94285C5.39383 7.19289 5.69058 7.33337 6 7.33337Z" fill="#FA9F17" />
                                            </svg>
                                        </span> : ''

                            }

                        </td>
                    }
                    {self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'general' ? '' :
                        self.props.getLoginRole.user.role === 'press' ? <td className="">{user?.pressAppliedDiscountCode !== null ? self.state.discount.filter(_ => _.identifier === user?.pressAppliedDiscountCode?.identifier)[0]?.couponCode : '-' }</td> : self.props.getLoginRole.user.role === 'sundanceGuest' ? <td className="">{user?.guestAppliedDiscountCode !== null ? self.state.discount.filter(_ => _.identifier === user?.guestAppliedDiscountCode?.identifier)[0]?.couponCode : '-' }</td> : <td className="">{user?.appliedDiscountCode !== null ? self.state.discount.filter(_ => _.identifier === user?.appliedDiscountCode?.identifier)[0]?.couponCode : '-' }</td>
                    }
                    {self.props.getLoginRole && self.props.getLoginRole.user && (self.props.getLoginRole.user.role === 'general' || self.props.getLoginRole.user.role === 'sundanceGuest') ? '' :
                        <td className="user_purchase_on">{((self.props.getLoginRole.user.role === 'press' && user?.presspurchasedAt) || (self.props.getLoginRole.user.role === 'sio' && user.purchasedAt)) ? purchasedAt : '-'}</td>
                    }
                    {self.props.getLoginRole && self.props.getLoginRole.user && (self.props.getLoginRole.user.role === 'general' || self.props.getLoginRole.user.role === 'sio' || self.props.getLoginRole.user.role === 'sundanceGuest') ? '' :
                        <td className="user_purchase_on">{user.registrationCompleteDate ? registrationCompleteDate : '-'}</td>
                    }
                    <td className="user_added_on">{user.lastLogin ? lastLogin : '-'}</td>
                    <td className="user_added_on"> {user.roleUpdateAt && moment(user.roleUpdateAt).tz("US/Mountain").format('MM/DD/YYYY h:mm A')} </td>
                    <td className="user_added_on">{createdAt}</td>
                    <td className="user_on">{(user && user.addedBy && user.addedBy.fname) + ' ' + (user && user.addedBy && user.addedBy.lname)}</td>
                    <td className="icon_d">
                        <Link onClick={() => self.openUserHistory(user)}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.65625 10.0625H6.34375V6.34375H7.65625V10.0625ZM7.65625 5.03125H6.34375V3.71875H7.65625V5.03125Z" fill="#5D737E"/>
                            </svg>
                            <div style={{width:'140px', left:'-64px', top:'-44px'}}>View User History & Information</div>
                        </Link>
                        {(self.props.getLoginRole.user.role !== 'general') && <Link onClick={(e) => self.resetRole(user._id)}>
                            <img src="/images/undo.png"  alt="revert" style={{width:"12px"}} /> <div style={{width:'120px', left:'-50px'}}>Remove {self.getRoleString([self.props.getLoginRole.user.role+'User'])} Role</div>
                        </Link>}
                        <Link onClick={(e) => self.purchaseReceipt(user.eventiveId)}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.34844 10.3938L7.35156 10.8891C7.35156 10.9578 7.29531 11.0156 7.22656 11.0156H6.78281C6.71406 11.0156 6.65781 10.9594 6.65781 10.8906V10.4C5.27031 10.2969 4.61719 9.50625 4.54688 8.64688C4.54063 8.57344 4.59844 8.51094 4.67188 8.51094H5.39375C5.45469 8.51094 5.50781 8.55469 5.51719 8.61406C5.59688 9.10938 5.98281 9.47969 6.675 9.57187V7.34219L6.28906 7.24375C5.47188 7.04844 4.69375 6.53906 4.69375 5.48281C4.69375 4.34375 5.55937 3.73125 6.66563 3.62344V3.10781C6.66563 3.03906 6.72188 2.98281 6.79063 2.98281H7.22969C7.29844 2.98281 7.35469 3.03906 7.35469 3.10781V3.61875C8.425 3.72656 9.22812 4.35156 9.32187 5.325C9.32969 5.39844 9.27187 5.4625 9.19687 5.4625H8.49531C8.43281 5.4625 8.37969 5.41563 8.37187 5.35469C8.30937 4.89844 7.94375 4.52656 7.34844 4.44531V6.54375L7.74531 6.63594C8.75781 6.88594 9.44687 7.37031 9.44687 8.45469C9.44687 9.63125 8.57187 10.2875 7.34844 10.3938ZM5.66563 5.41094C5.66563 5.80781 5.91094 6.11562 6.43906 6.30625C6.5125 6.33594 6.58594 6.35938 6.67344 6.38438V4.44688C6.09688 4.52031 5.66563 4.84375 5.66563 5.41094ZM7.48594 7.52344C7.44219 7.51406 7.39844 7.50312 7.34844 7.48906V9.57812C8.01406 9.51875 8.47344 9.15312 8.47344 8.54062C8.47344 8.06094 8.225 7.74844 7.48594 7.52344Z" fill="#5D737E" />
                            </svg>
                            <div style={{top:'-43px'}}>Purchase History</div>
                        </Link>
                        {/* <Link style={{ width: "20px" }} onClick={(e) => self.handelDeviceModel(user._id)} >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.25 4.375V14.375H18.75V4.375H1.25ZM2.5 5.625H17.5V13.125H2.5V5.625ZM6.25 15V16.25H13.75V15H6.25Z" fill="#5D737E" />
                            </svg>

                        </Link> */}
                        <Link onClick={self.editUser.bind(this, user._id, false)}><EditIcon /><div>edit</div></Link>
                        <Link onClick={self.lockUser.bind(this, user._id, user.isBlocked)}>
                            {!user.isBlocked ? <LockIcon /> : <LockCloseIcon />}
                            <div>{!user.isBlocked ? 'block' : 'unblock'}</div>
                        </Link>
                        <Link onClick={self.deleteUser.bind(this, user._id, user.isDeleted, user.orderCount)}><DeleteIcon /><div>delete</div></Link>
                        <Link onClick={user.addedType === 'general' ? self.loginUserGeneral.bind(this, user._id) : self.loginUser.bind(this, user._id)}><ShareIcon /></Link>

                        {self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'general' ?
                            <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                </svg>
                                <span className="tooltip_box">Send invitation email</span>
                            </label> : ''
                        }
                        {
                            user.addedType === 'admin' || user.addedType === 'csv' ?
                                user.purchaseStatus === 'complete' && user.status === 'confirmed' ?
                                <>
                                    <span className="d_flex" style={{background: '#f2f2f2'}}>
                                        {/* both disable approve and email btn */}
                                        {self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'sio' && <label className="check_admin disable" style={{ cursor: 'not-allowed' }}>
                                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                            </svg>
                                        </label>}
                                        <label className="check_admin disable">
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                            </svg>
                                        </label>
                                    </span>
                                </> :
                                user.purchaseStatus === 'complete' && user.status === "invited" ?
                                <>
                                    <span className="d_flex" style={{background: '#f2f2f2'}}>
                                        {/* disable approve btn */}
                                        {self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'sio' && <label className="check_admin disable" style={{ cursor: 'not-allowed' }}>
                                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                            </svg>
                                        </label>}
                                        {/* enable email btn */}
                                        <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                            </svg>
                                            <span className="tooltip_box">Send invitation email</span>
                                        </label>
                                    </span>
                                </> :
                                ((user.purchaseStatus === 'waiting' || user.purchaseStatus === 'pending') && user.status === 'pendingConfirmation') || (user.purchaseStatus === 'waiting' && user.status === 'pendingPass') || (user.purchaseStatus === 'pending' && user.status === 'pendingPass') ?
                                <>
                                    <span className="d_flex" style={{background: '#f2f2f2'}}>
                                        {/* both enable approve and email btn */}
                                        {self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'sio' && <label className={user.status === 'pendingPass' ? "check_admin disable" : "check_admin"} onClick={user.status !== 'pendingPass' && self.approveUserPopup.bind(this, user)} disabled={user.status === 'pendingPass' ? true : false}>
                                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                            </svg>
                                        </label>}
                                        <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                            </svg>
                                            <span className="tooltip_box">Send invitation email</span>
                                        </label>
                                    </span>
                                </> :
                                user.purchaseStatus === 'pending' && (user.status === "invited") || (user.status === 'confirmed') ?
                                <>
                                    {/* disable approve btn */}
                                    <span className="d_flex" style={{background: '#f2f2f2'}}>
                                        {self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'sio' && <label className="check_admin disable" style={{ cursor: 'not-allowed' }}>
                                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                            </svg>
                                        </label>}
                                        {/* enable email btn */}
                                        <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                            </svg>
                                            <span className="tooltip_box">Send invitation email</span>
                                        </label>
                                    </span>
                                </> : ''
                            :
                            user.addedType === 'manual' ?
                                user.purchaseStatus === 'waiting' && user.status === 'pending' ? '' :
                                    user.purchaseStatus === "complete" && user.status === 'confirmed' ?
                                    <>
                                        {/* both enable approve and email btn */}
                                        <span className="d_flex" style={{background: '#f2f2f2'}}>
                                            <label className="check_admin disable" style={{ cursor: 'not-allowed' }}>
                                                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                                </svg>
                                            </label>
                                            <label className="check_admin disable">
                                                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                                </svg>
                                            </label>    
                                        </span>
                                    </> :
                                    user.purchaseStatus === 'complete' && user.status === "invited" ?
                                    <>
                                        <span className="d_flex" style={{background: '#f2f2f2'}}>
                                            {/* disable approve btn */}
                                            <label className="check_admin disable" style={{ cursor: 'not-allowed' }}>
                                                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                                </svg>
                                            </label>
                                            {/* enable email btn */}
                                            <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                                </svg>
                                                <span className="tooltip_box">Send invitation email</span>
                                            </label>
                                        </span>
                                    </> :
                                    (user.purchaseStatus === 'pending' && user.status === 'confirmed' && self.props.getLoginRole && self.props.getLoginRole.user && self.props.getLoginRole.user.role === 'sio') ?
                                        <>
                                            {/* disable approve btn */}
                                            <label className={"check_admin unapprove"} onClick={user.status !== 'pendingPass' && self.unapproveUserPopup.bind(this, user)} disabled={user.status === 'pendingPass' ? true : false}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 18 18">
                                                    <path fill="#ffffff" d="M17.558 15.44a1.49 1.49 0 0 1 0 2.12 1.5 1.5 0 0 1-2.12 0L9 11.12l-6.438 6.44a1.5 1.5 0 0 1-2.12 0 1.49 1.49 0 0 1 0-2.12L6.88 9 .442 2.563a1.5 1.5 0 0 1 2.12-2.12L9 6.883l6.438-6.44a1.5 1.5 0 0 1 2.12 2.12L11.12 9z"/>
                                                </svg>
                                            </label>
                                            {/* enable email btn */}
                                            <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                                </svg>
                                                <span className="tooltip_box">Send invitation email</span>
                                            </label>
                                        </> :
                                        ((user.purchaseStatus === 'waiting' || user.purchaseStatus === 'pending') && user.status === 'pendingConfirmation') || (user.purchaseStatus === 'waiting' && user.status === 'pendingPass') || (user.purchaseStatus === 'pending' && user.status === 'pendingPass') ?
                                        <>
                                            {/* both enable approve and email btn */}
                                            <span className="d_flex" style={{background: '#f2f2f2'}}>
                                                {((user.purchaseStatus === 'waiting' || user.purchaseStatus === 'pending') && user.status === 'pendingPass') ? "" :
                                                    <label className={(user.status === 'pendingPass' || localStorage.getItem('currentUserRole') !== 'sio') ? "check_admin disable" : "check_admin 1"} onClick={user.status !== 'pendingPass' && self.approveUserPopup.bind(this, user)} disabled={user.status === 'pendingPass' ? true : false}>
                                                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.6656 0.9375L6.33437 10.6031L2 6.27187L0 8.27188L6.66563 14.9375L16 2.9375L13.6656 0.9375Z" fill="#ffffff" />
                                                        </svg>
                                                    </label>
                                                }

                                                <label className="check_admin" onClick={self.sendEmailPopup.bind(this, user)}>
                                                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                                    </svg>
                                                    <span className="tooltip_box">Send invitation email</span>
                                                </label>
                                            </span>
                                        </> : ''
                                : ''
                        }

                    </td>
                </tr>
            )
        })
    }

    editUser = (userId, allSearch) => {

        var role = this.props.getLoginRole.user.role;
        if (role === 'sio') {
            this.setState({
                createSIOuser: true
            }, () => {
                this.refs && this.refs.sioUser && this.refs.sioUser.getUserData(userId, allSearch)
            })
        }
        else if (role === 'press' || role === 'artist') {
            this.setState({
                createPressuser: true
            }, () => {
                this.refs && this.refs.pressUser && this.refs.pressUser.getUserData(userId, allSearch)
            })
        }
        else if (role === 'sundanceGuest') {
            this.setState({
                createCircleuser: true
            }, () => {
                this.refs && this.refs.circleUser && this.refs.circleUser.getUserData(userId, allSearch)
            })
        }
        else if (role === 'general') {
            this.setState({
                createGeneraluser: true
            }, () => {
                this.refs && this.refs.generalUser && this.refs.generalUser.getUserData(userId, allSearch)
            })
        }


    }

    syncUser = (userId) => {
        this.setState({isSync:true, syncId:userId})
        var data = { userId: userId, }
        this.apiserve.sendevent("user|syncLibrary", data);
    }

    lockUser = (userId, status) => {
        var data = {
            userId: userId,
            isBlocked: !status
        }

        this.apiserve.sendevent("admin|blockUser", data);
    }

    deleteUser = (userId, status, orderCount) => {
        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    if (orderCount) {
                        this.setState({
                            errorPopup: true,
                            errorMsg: `This user already has one or more items in My Purchases and can't be deleted`
                        })
                    } else {
                        var data = {
                            userId: userId,
                            isRemoved: !status
                        }

                        this.apiserve.sendevent("admin|removeUser", data);
                    }

                } else {
                    swal("Your record is safe!");
                }
            });


    }
    resetRole = (userId) => {
        const { getLoginRole } = this.props;
        swal({
            title: "Are you sure?",
            text:  `You are about to remove ${getLoginRole && getLoginRole.user && getLoginRole.user.role === 'press' ? 'Press'
                : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sio' ? 'Industry'
                    : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'general' ? 'General'
                        : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'artist' ? 'Artist'
                            : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sundanceGuest' ? 'Sundance Guest'
                                : ''} role from this user`,
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                var data = {
                    userId: userId,
                }
                this.apiserve.sendevent("admin|removeRoleUser", data);

            } else {
                swal("Your User is safe!");
            }
        });
    }

    loginUser = (userId) => {
        let data = {
            id: userId
        }
        this.apiserve.sendevent("loginUser", data);
    }

    loginUserGeneral = (userId) => {
        let data = {
            id: userId,
            role: "generalUser",
        }
        this.apiserve.sendevent("generalUser|generalUserGostLogin", data);
    }

    downloadcsv = () => {
        let data ={}
        if (discountTypeArray && discountTypeArray.length) {
            data['filters'] = discountTypeArray
        }
        if (accessTypeArray && accessTypeArray.length) {
            data['passType'] = accessTypeArray
        }
        if (approveStatus && approveStatus.length) {
            data['status'] = approveStatus
        }
        if (purchaseFilterArray && purchaseFilterArray.length) {
            data.purchaseStatus = purchaseFilterArray
        }
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        this.apiserve.sendevent("admin|getUserCsv", data);
    }

    uploadCSV = (e) => {
        let file = e.target.files[0];
        if ((file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') || file.name.includes('.csv')) {
            this.setState({
                fileUploading: true
            })
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {
                setTimeout(() => {
                    this.imageUploadScreen(file,false,event.target.result);
                }, 0);
            };
            e.target.value = ''
        } else {
            this.setState({ errorMsg: 'please upload .csv file only', errorPopup: true, fileUploading: false })
        }
        e.target.value = null;
    }

    imageUploadScreen = (file,IsFPGUpload=true,img) => {
        let role = localStorage.getItem('currentUserRole');
        var fileSet = commonImage(file,IsFPGUpload, '', img,'', STORAGE_PATHS.USERS.CSV[role.toUpperCase()].IMPORT);
        fileSet.then((value) => {
            var data1 = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value)
            }
            this.apiserve.sendevent("admin|importCsv", data1);
        });

    };

    uploadCSVGeneral = (e) => {
        this.setState({
            fileUploadingGeneral: true
        })
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            setTimeout(() => {
                this.imageUploadScreenGeneral(file,event.target.result);
            }, 0);
        };
        e.target.value = null;
    }

    imageUploadScreenGeneral = (file,img) => {
        let role = localStorage.getItem('currentUserRole');
        var fileSet = commonImage(file,false,'',img,'', STORAGE_PATHS.USERS.CSV[role.toUpperCase()].IMPORT);
        fileSet.then((value) => {
            var data1 = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value)
            }
            this.apiserve.sendevent("generalUser|importCsv", data1);
        });

    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: false
            },
            () => {
                this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                    this.getGeneralList(this.state.offset, this.state.perPage) :
                    this.getEventList(offset, this.state.perPage, purchaseFilterArray, discountTypeArray,accessTypeArray,approveStatus);
            }
        );
    };

    getInvitationLink = (link) => {
        if (link) {
            CopyToClipboard(link);
            this.apiserve.success('Link Copied!')
        }
    }

    purchaseFilter = (e, selectedInex) => {
        let index = selectedInex
        let event = e.target.checked

        let purchaseTypeList = [...this.state.purchase]
        purchaseTypeList.forEach((key, i) => {
            if (i === index) {
                purchaseTypeList[i].value = event
            }
        })
        this.setState({
            ...this.state,
            purchase: purchaseTypeList,
            currentPage: 0
        }, () => {
            if (event) {
                purchaseFilterArray = [...purchaseFilterArray, this.state.purchase[index].name];
            } else {
                let tempArray = purchaseFilterArray.filter((d) => d !== this.state.purchase[index].name);
                purchaseFilterArray = tempArray;
            }
            localStorage.setItem('currentPage', this.state.currentPage)
            localStorage.setItem('perPage', this.state.perPage)
            localStorage.setItem('offset', this.state.offset)
            this.getAllFilter(this.state.offset, this.state.perPage);

        })
    }

    accessPassFilter = (e, selectedInex, isClearAllAccessType = false, isClearApprovedType = false, isClearAllDiscount = false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked

        let accessTypeList = [...this.state.accessPass]
        accessTypeList.forEach((key, i) => {
            if (i === index) {
                accessTypeList[i].value = event
            }
            if (isClearAllAccessType) {
                accessTypeList[i].value = false
                accessTypeArray = []
            }

        })
        this.setState({
            ...this.state,
            accessPass: accessTypeList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    accessTypeArray = [...accessTypeArray, this.state.accessPass[index].identifier];
                }

            } else {
                if (index !== null) {
                    let tempArray = accessTypeArray.filter((d) => d !== this.state.accessPass[index].identifier);
                    accessTypeArray = tempArray;
                }
            }
            this.getAllFilter(this.state.offset, this.state.perPage, isClearAllAccessType, isClearApprovedType, isClearAllDiscount);
        })
    }
    discountFilter = (e, selectedInex, isClearAllAccessType = false, isClearApprovedType = false,isClearAllDiscount = false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let discountList = [...this.state.discount];
        discountList.forEach((key, i) => {
            if (discountList[index]?.couponCode !== 'None') {
                if(i === index){
                    discountList[i].value = event
                } else if(key.couponCode === 'None'){
                    discountList[i].value = false
                }
            } else if(discountList[index]?.couponCode === 'None'){
                if(i === index) {
                    discountList[i].value = event
                } else {
                    discountList[i].value = false
                }
            } 
            if (isClearAllDiscount) {
                discountList[i].value = false
                discountTypeArray = []
            }
            
        })
        
            this.setState({
                ...this.state,
                discount: discountList,
                currentPage: 0
            }, () => {
            if (event) {
                if (index !== null) {
                    discountTypeArray = discountList.map(item => item.value && item.identifier).filter(_ => _ !== false)
                }
                
            } else {
                if (index !== null) {
                    let tempArray = discountTypeArray.filter((d) => d !== this.state.discount[index].identifier);
                    discountTypeArray = tempArray;
                }
            }
            this.getAllFilter(this.state.offset, this.state.perPage, isClearAllAccessType, isClearApprovedType,isClearAllDiscount);
        })
    }

    approveFilter = (e, selectedInex, isClearAllAccessType = false, isClearApprovedType = false, isClearAllDiscount = false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = [...this.state.approvePass]
        approvePassList.forEach((key, i) => {
            if (i === index) {
                approvePassList[i].value = event
            }
            if (isClearApprovedType) {
                approvePassList[i].value = false
                approveStatus = []
            }

        })
        this.setState({
            ...this.state,
            approvePass: approvePassList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    approveStatus = [...approveStatus, this.state.approvePass[index].list];
                }

            } else {
                if (index !== null) {
                    let tempArray = approveStatus.filter((d) => d !== this.state.approvePass[index].list);
                    approveStatus = tempArray;
                }
            }
            this.getAllFilter(this.state.offset, this.state.perPage, isClearAllAccessType, isClearApprovedType,isClearAllDiscount);
        })
    }

    getAllFilter = (skip, limit, isClearAllAccessType, isClearApprovedType, isClearAllDiscount) => {
        let data = {
            page: 1,
            limit: limit
        }
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (purchaseFilterArray && purchaseFilterArray.length) {
            data.purchaseStatus = purchaseFilterArray
        }
        if (!isClearAllAccessType && accessTypeArray && accessTypeArray.length) {
            data.passType = accessTypeArray
        }
        if (!isClearAllDiscount && discountTypeArray && discountTypeArray.length) {
            data.discount = discountTypeArray
        }

        if (!isClearApprovedType && approveStatus && approveStatus.length) {
            data.status = approveStatus
        }
        this.setState({loaderFlagData:true})
        this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
            this.apiserve.sendevent("generalUser|getAllUser", data) :
            this.apiserve.sendevent("admin|getAllUser", data);
    }

    clearAllPurchase = (skip, limit) => {
        purchaseFilterArray = []
        this.setState({
            purchase: [
                { assign: "Purchased", name: "complete", value: false },
                { assign: " Purchase Pending", name: "pending", value: false },
            ]
        })
        let data = {
            page: 1,
            limit: limit
        }
        if (purchaseFilterArray && purchaseFilterArray.length) {
            data.purchaseStatus = purchaseFilterArray
        }

        if (accessTypeArray && accessTypeArray.length) {
            data.passType = accessTypeArray
        }
        if (discountTypeArray && discountTypeArray.length) {
            data.discount = discountTypeArray
        }

        if (approveStatus && approveStatus.length) {
            data.status = approveStatus
        }
        this.setState({loaderFlagData:true})
        this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
            this.apiserve.sendevent("generalUser|getAllUser", data) :
            this.apiserve.sendevent("admin|getAllUser", data);
    }

    //Search Data
    onSearchFilter = (e) => {

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        const { name, value } = e.target
        const Value = value
        let self = this
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        })
        this.setState({
            typing: false,
            typingTimeout: setTimeout(function() {
                var data = {
                    page: 1,
                    limit: 50
                }
                if (Value.length) {
                    data.filter = Value
                }
                if (this.state?.searchField?.length) {
                    data.filter = this.state.searchField
                }
                if (purchaseFilterArray && purchaseFilterArray.length) {
                    data.purchaseStatus = purchaseFilterArray
                }
                if (accessTypeArray && accessTypeArray.length) {
                    data.passType = accessTypeArray
                }
                if (discountTypeArray && discountTypeArray.length) {
                    data.discount = discountTypeArray
                }
                if (approveStatus && approveStatus.length) {
                    data.status = approveStatus
                }
                self.setState({loaderFlagData:true})
                self.props.getLoginRole && self.props.getLoginRole?.user && self.props.getLoginRole?.user.role === 'general' ?
                self.apiserve.sendevent("generalUser|getAllUser", data) :
                self.apiserve.sendevent("admin|getAllUser", data);
              }, 500)
        });
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    //  Copy address
    CopyLinkAddress = (copy) => {
        if (copy) {
            navigator.clipboard.writeText(copy);
            this.setState({
                copylinkflag: true,
                copyiconflag: true
            })
            setTimeout(() => {
                this.setState({
                    copyiconflag: false
                })
            }, 2000);
        }
        else {

        }

    }

    render() {
        const { getLoginRole } = this.props;
        const { purchase, accessPass, getTotalDocs, approvePass, discount } = this.state
        return (
            <React.Fragment>

                <div className={getLoginRole && getLoginRole.user && getLoginRole.user.role === 'general' ? "right_side_wrapper adminDashboard_wrapper adminDashboard_wrapper1" : "right_side_wrapper adminDashboard_wrapper"}>
                    <div className="dashboard_header with_btn">
                        <div className="searchBlock">
                            {getTotalDocs !== undefined ?
                                <span>{getLoginRole && getLoginRole.user && getLoginRole.user.role === 'press' ? 'Press Users'
                                    : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sio' ? 'Industry Users'
                                        : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'general' ? 'General'
                                            : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'artist' ? 'Artist'
                                                : getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sundanceGuest' ? 'Sundance Guest'
                                                    : ''}
                                    {getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sundanceCircle' ? ' (' + getTotalDocs + ')' : ' (' + getTotalDocs + ')'}
                                </span>
                                :
                                ''}
                            <form onSubmit={e => { e.preventDefault(); }}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    id="searchField"
                                    name="searchField"
                                    value={this.state.searchField}
                                    onChange={this.onSearchFilter} />
                                <button type='button' style={{ pointerEvents: 'none' }}>
                                    <img src={serachIcon} />
                                </button>
                            </form>
                        </div>

                        <div className="button_block admin_user_twoBtn">
                            {getLoginRole ?.user ?.role === 'general' ?
                                <>
                                <div className="icon_block">
                                    <Link onClick={() => this.downloadcsv()}><img src={cloud} /></Link>
                                </div>
                                <span className="head_btn pointer" onClick={this.searchUsers}>Create User</span>
                                <span className="head_btn pointer upload_csv_btn"><input type="file" accept=".csv" onChange={this.uploadCSVGeneral} />Upload CSV {this.state.fileUploadingGeneral &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</span>
                                </>
                                :
                                <>
                                <div className="icon_block">
                                    <Link onClick={() => this.downloadcsv()}><img src={cloud} /></Link>

                                </div>
                                <span className={getLoginRole && getLoginRole.user && (getLoginRole.user.role === 'press') ? "head_btn pointer get_invitation get_invitation_disable" : "head_btn pointer get_invitation"} onClick={() => (getLoginRole && getLoginRole.user && (getLoginRole.user.role === 'press')) ? '' : this.getInvitationLink(this.state.copyLink)}>Get Invitation Link</span>
                                <span className="head_btn pointer" onClick={this.searchUsers}>Create User</span>
                                <span className="head_btn pointer upload_csv_btn"><input type="file" accept=".csv" onChange={this.uploadCSV} />Upload CSV {this.state.fileUploading &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</span>
                                </>
                            }
                        </div>

                    </div>
                    <div className="dashboard_data film_list_table striped_table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="user_email_d">
                                        <span>
                                            Email
                                            {getLoginRole?.user?.role === 'general' ? '' :
                                                purchaseFilterArray && purchaseFilterArray.length ?
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                                                        <circle cx="8" cy="2" r="2" fill="black" />
                                                    </svg>
                                                    :
                                                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                                                    </svg>

                                            }
                                        </span>
                                        {getLoginRole?.user?.role === 'general' ? '' :
                                            <div className="tabelData_popup">
                                                <form>
                                                    <div className="customCheck">
                                                        <>
                                                        <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                            <p className="link" onClick={() => this.clearAllPurchase(this.state.offset, this.state.perPage)}>Clear All</p>
                                                        </div>
                                                        {purchase.map((item, i) => (
                                                            <div className="customCheckBox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={item.name}
                                                                    name={item.name}
                                                                    value={item.value ? true : false}
                                                                    checked={item.value ? true : false}
                                                                    onClick={(e) => this.purchaseFilter(e, i)}
                                                                />
                                                                <label htmlFor={item.name}>
                                                                    <span className="check_icon d_flex">
                                                                        {item.name === 'complete' ?
                                                                            <svg className="active" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path fillRule="evenodd" clip-rule="evenodd" d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5H0ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.711V10.71Z" fill="black" />
                                                                            </svg>

                                                                            :
                                                                            <svg className="" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M7.41319 0.104126C9.46181 0.104126 11.2095 0.827506 12.6562 2.27427C14.103 3.72102 14.8264 5.46292 14.8264 7.49996C14.8264 9.537 14.103 11.2789 12.6562 12.7257C11.2095 14.1724 9.46181 14.8958 7.41319 14.8958C5.36458 14.8958 3.6169 14.1724 2.17014 12.7257C0.72338 11.2789 0 9.537 0 7.49996C0 5.46292 0.72338 3.72102 2.17014 2.27427C3.6169 0.827506 5.36458 0.104126 7.41319 0.104126ZM8.15972 11.2152V9.72218H6.66667V11.2152H8.15972ZM8.15972 8.22913V3.78468H6.66667V8.22913H8.15972Z" fill="#FF8311" />
                                                                            </svg>
                                                                        }
                                                                        {item.assign}
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))
                                                        }
                                                        </>
                                                    </div>
                                                </form>
                                            </div>
                                        }
                                    </th>
                                    <th className="user_firstName_d">First Name</th>
                                    <th className="user_lastName_d">Last Name</th>
                                    <th className="user_company_d">Company</th>
                                    {(getLoginRole?.user?.role === 'general' || getLoginRole?.user?.role === 'sundanceGuest') ? '' :
                                        <th className="user_pass">

                                            <span className="d_flex d_flex_align_center">
                                                Pass

                                                {accessTypeArray && accessTypeArray.length ?
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                                                        <circle cx="8" cy="2" r="2" fill="black" />
                                                    </svg>
                                                    :
                                                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                                                    </svg>
                                                }
                                            </span>

                                            <div className="tabelData_popup">
                                                <form>
                                                    <div className="customCheck">
                                                        <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                            <p className="link" onClick={() => this.accessPassFilter(null, null, true, null)}>Clear All</p>
                                                            <p>Select one or more</p>
                                                        </div>
                                                        {accessPass.map((item, i) => (
                                                            <div className="customCheckBox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={item.name}
                                                                    name={item.name}
                                                                    value={item.name ? true : false}
                                                                    checked={item.value ? true : false}
                                                                    onClick={(e) => this.accessPassFilter(e, i)}
                                                                />
                                                                <label htmlFor={item.name}>{item.name}</label>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </th>
                                    }
                                    {getLoginRole?.user?.role === 'general' ? '' :
                                        <th className="user_pass">

                                            <span className="d_flex d_flex_align_center">
                                                Discount
                                                {discountTypeArray && discountTypeArray.length ?
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                                                        <circle cx="8" cy="2" r="2" fill="black" />
                                                    </svg>
                                                    :
                                                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                                                    </svg>
                                                }
                                            </span>

                                            <div className="tabelData_popup">
                                                <form>
                                                    <div className="customCheck">
                                                        <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                            <p className="link" onClick={() => this.discountFilter(null, null, null, null,true)}>Clear All</p>
                                                            <p>Select one or more</p>
                                                        </div>
                                                        {discount.map((item, i) => (
                                                            <div className="customCheckBox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={'l'+item._id}
                                                                    name={item.identifier}
                                                                    value={item.identifier ? true : false}
                                                                    checked={item.value ? true : false}
                                                                    onClick={(e) => this.discountFilter(e, i)}
                                                                />
                                                                <label htmlFor={'l'+item._id}>{item.couponCode}</label>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </th>
                                    }
                                    {(getLoginRole?.user?.role === 'general' || getLoginRole.user.role === 'sundanceGuest') ? '' :
                                        <th className="user_purchase_on">Purchased On (MT)</th>
                                    }
                                    {(getLoginRole?.user?.role === 'general' || getLoginRole?.user?.role === 'sio' || getLoginRole.user.role === 'sundanceGuest') ? '' :
                                        <th className="user_purchase_on">Registered (MT)</th>
                                    }
                                    <th className="user_added_on">last Logged On (MT)</th>
                                    <th className='user_added_on'>Role Updated</th>
                                    <th className="user_added_on">Added On (MT)</th>
                                    <th className="user_added_on">Added By</th>

                                    <th className="icon_d" style={{ justifyContent: "center" }}>
                                        {getLoginRole?.user?.role === 'general' ? '' :
                                            <>
                                            <span className="d_flex d_flex_align_center status_heading">
                                                Status

                                                    {approveStatus && approveStatus.length ?
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                                                        <circle cx="8" cy="2" r="2" fill="black" />
                                                    </svg>
                                                    :
                                                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                                                    </svg>
                                                }
                                            </span>

                                            <div className="tabelData_popup">
                                                <form>
                                                    <div className="customCheck">
                                                        <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                            <p className="link" onClick={() => this.approveFilter(null, null, null, true)}>Clear All</p>
                                                        </div>
                                                        {approvePass.map((item, i) => (
                                                            <div className="customCheckBox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={'status' + item.list}
                                                                    name={'status' + item.list}
                                                                    value={item.list ? true : false}
                                                                    checked={item.value ? true : false}
                                                                    onClick={(e) => this.approveFilter(e, i)}
                                                                />
                                                                <label htmlFor={'status' + item.list}>{item.assign}</label>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                            </>
                                        }
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loaderFlagData && <Loader />}
                                {
                                    this.state.users && this.state.users.length > 0 ? this.getUserData() : <tr><div className="sd_user_0">{!this.state.loaderFlagData && `Users not Found` }</div></tr>
                                }
                                {this.state.users && this.state.users.length && this.state.users ? (
                                    <div className="custom-pagination">
                                        <ReactPaginate
                                            previousLabel={""}
                                            nextLabel={""}
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            forcePage={this.state.currentPage}
                                        />
                                    </div>
                                ) : (
                                        ""
                                    )}

                            </tbody>
                        </table>
                    </div>
                    {/* For resend Mail */}
                    <div className={`user_popup ${this.state.MailSendPopup ? "active" : ''}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>Do you want to send the email to {this.state.userForResendMail.fname + ' ' + this.state.userForResendMail.lname} again?</p>
                                <span className="close_popup" onClick={this.CloseModal}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                    </svg>
                                </span>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="" onClick={this.CloseModal}>Cancel</button>
                                    <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    }</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mail send 2 */}
                    <div className={`user_popup ${this.state.resendMailPopup ? "active" : ''}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow mailsend_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p> Get {this.state.userForResendMail.fname + ' ' + this.state.userForResendMail.lname + `'s`} Unique Registration Link:</p>
                                <span className="close_popup" onClick={this.CloseModal}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                    </svg>
                                </span>
                            </div>
                            <div className="content">
                                <div>
                                    <div className="copy_link d_flex d_flex_justify_spacebt d_flex_align_center">
                                        <h4 className="uppercase link_address">{this.state.mailLink ? this.state.mailLink : this.state.loginLink}</h4>
                                        <span className="pointer" onClick={() =>
                                            this.CopyLinkAddress(`${this.state.mailLink ? this.state.mailLink : this.state.loginLink}`)}>                                             {!this.state.copyiconflag ?
                                                <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21.5 8.43004C21.4878 8.32287 21.4644 8.21728 21.43 8.11504V8.01004C21.3739 7.89008 21.2991 7.77982 21.2083 7.68337L14.2083 0.683374C14.1119 0.592626 14.0016 0.517802 13.8817 0.461707C13.8468 0.456761 13.8115 0.456761 13.7767 0.461707C13.6582 0.393739 13.5273 0.350109 13.3917 0.333374H8.66667C7.73841 0.333374 6.84817 0.702123 6.19179 1.3585C5.53542 2.01488 5.16667 2.90512 5.16667 3.83337V5.00004H4C3.07174 5.00004 2.1815 5.36879 1.52513 6.02517C0.868749 6.68154 0.5 7.57178 0.5 8.50004V20.1667C0.5 21.095 0.868749 21.9852 1.52513 22.6416C2.1815 23.298 3.07174 23.6667 4 23.6667H13.3333C14.2616 23.6667 15.1518 23.298 15.8082 22.6416C16.4646 21.9852 16.8333 21.095 16.8333 20.1667V19H18C18.9283 19 19.8185 18.6313 20.4749 17.9749C21.1313 17.3185 21.5 16.4283 21.5 15.5V8.50004V8.43004ZM14.5 4.31171L17.5217 7.33337H15.6667C15.3572 7.33337 15.0605 7.21046 14.8417 6.99167C14.6229 6.77287 14.5 6.47613 14.5 6.16671V4.31171ZM14.5 20.1667C14.5 20.4761 14.3771 20.7729 14.1583 20.9917C13.9395 21.2105 13.6428 21.3334 13.3333 21.3334H4C3.69058 21.3334 3.39383 21.2105 3.17504 20.9917C2.95625 20.7729 2.83333 20.4761 2.83333 20.1667V8.50004C2.83333 8.19062 2.95625 7.89388 3.17504 7.67508C3.39383 7.45629 3.69058 7.33337 4 7.33337H5.16667V15.5C5.16667 16.4283 5.53542 17.3185 6.19179 17.9749C6.84817 18.6313 7.73841 19 8.66667 19H14.5V20.1667ZM19.1667 15.5C19.1667 15.8095 19.0438 16.1062 18.825 16.325C18.6062 16.5438 18.3094 16.6667 18 16.6667H8.66667C8.35725 16.6667 8.0605 16.5438 7.84171 16.325C7.62292 16.1062 7.5 15.8095 7.5 15.5V3.83337C7.5 3.52396 7.62292 3.22721 7.84171 3.00842C8.0605 2.78962 8.35725 2.66671 8.66667 2.66671H12.1667V6.16671C12.1667 7.09497 12.5354 7.9852 13.1918 8.64158C13.8482 9.29796 14.7384 9.66671 15.6667 9.66671H19.1667V15.5Z" fill="black" />
                                                </svg>
                                                :
                                                <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21.5 8.43004C21.4878 8.32287 21.4644 8.21728 21.43 8.11504V8.01004C21.3739 7.89008 21.2991 7.77982 21.2083 7.68337L14.2083 0.683374C14.1119 0.592626 14.0016 0.517802 13.8817 0.461707C13.8468 0.456761 13.8115 0.456761 13.7767 0.461707C13.6582 0.393739 13.5273 0.350109 13.3917 0.333374H8.66667C7.73841 0.333374 6.84817 0.702123 6.19179 1.3585C5.53542 2.01488 5.16667 2.90512 5.16667 3.83337V5.00004H4C3.07174 5.00004 2.1815 5.36879 1.52513 6.02517C0.868749 6.68154 0.5 7.57178 0.5 8.50004V20.1667C0.5 21.095 0.868749 21.9852 1.52513 22.6416C2.1815 23.298 3.07174 23.6667 4 23.6667H13.3333C14.2616 23.6667 15.1518 23.298 15.8082 22.6416C16.4646 21.9852 16.8333 21.095 16.8333 20.1667V19H18C18.9283 19 19.8185 18.6313 20.4749 17.9749C21.1313 17.3185 21.5 16.4283 21.5 15.5V8.50004V8.43004ZM14.5 4.31171L17.5217 7.33337H15.6667C15.3572 7.33337 15.0605 7.21046 14.8417 6.99167C14.6229 6.77287 14.5 6.47613 14.5 6.16671V4.31171ZM14.5 20.1667C14.5 20.4761 14.3771 20.7729 14.1583 20.9917C13.9395 21.2105 13.6428 21.3334 13.3333 21.3334H4C3.69058 21.3334 3.39383 21.2105 3.17504 20.9917C2.95625 20.7729 2.83333 20.4761 2.83333 20.1667V8.50004C2.83333 8.19062 2.95625 7.89388 3.17504 7.67508C3.39383 7.45629 3.69058 7.33337 4 7.33337H5.16667V15.5C5.16667 16.4283 5.53542 17.3185 6.19179 17.9749C6.84817 18.6313 7.73841 19 8.66667 19H14.5V20.1667ZM19.1667 15.5C19.1667 15.8095 19.0438 16.1062 18.825 16.325C18.6062 16.5438 18.3094 16.6667 18 16.6667H8.66667C8.35725 16.6667 8.0605 16.5438 7.84171 16.325C7.62292 16.1062 7.5 15.8095 7.5 15.5V3.83337C7.5 3.52396 7.62292 3.22721 7.84171 3.00842C8.0605 2.78962 8.35725 2.66671 8.66667 2.66671H12.1667V6.16671C12.1667 7.09497 12.5354 7.9852 13.1918 8.64158C13.8482 9.29796 14.7384 9.66671 15.6667 9.66671H19.1667V15.5Z" fill="#9B9B9B" />
                                                </svg>
                                            }
                                        </span>
                                    </div>
                                    {this.state.copylinkflag ?
                                        <div className="mt_5">
                                            <p className="text_center copy_message">Link has been copied to clipboard</p>
                                        </div>
                                        :
                                        ''
                                    }
                                    <div className="mt_25 mb_25 text_center">
                                        <p>Do you want to send the invitation email to </p>
                                        <p> {this.state.userForResendMail.fname + ' ' + this.state.userForResendMail.lname} again?</p>
                                    </div>
                                </div>
                                <div className="field_row text_center">
                                    <button className="" onClick={this.CloseModal}>NO</button>
                                    <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    }</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* For Approval */}
                    <div className={`user_popup ${this.state.checkApprove ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_pass_popup bg_white">
                            <div className="approve_popup_header relative text_center">
                                <p>{this.state.userForApprove.fname + ' ' + this.state.userForApprove.lname} has requested the following pass</p>
                                <span className="close_popup" onClick={this.CloseModal}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                    </svg>
                                </span>
                            </div>
                            <div className={this.state.displayPass && (this.state.displayPass.discountPrice !== '') ? "pricing_row d_flex d_flex_align_center d_flex_justify_spacebt sd_early_price" : "pricing_row d_flex d_flex_align_center d_flex_justify_spacebt"}>
                                <h3 className="title">{this.state.displayPass && this.state.displayPass.name}</h3>
                                <h2 className="price">${this.state.displayPass && this.state.displayPass.price}</h2>
                                {this.state.displayPass && (this.state.displayPass.discountPrice !== '') && <h2 className="earlyPrice">${this.state.displayPass.discountPrice}</h2>}
                            </div>
                            <div className="content">
                                <div className="d_flex complist_approve">
                                    {this.state.discount.filter(_ => this.state.userForApprove && !this.state.userForApprove?.isEarlyPrice ? _.isEarlyComp === false && _.couponCode !== 'None' : _.couponCode !== 'None').map((item, i) => {
                                        return (
                                            <div key={i} className={item.isEarlyPrice ? 'sio_early_code' : ''}>
                                                <CheckBox name={item.identifier} checked={item._id === this.state.userForApprove?.appliedDiscountCode?._id} onChange={this.makeItComp} label={item.couponCode} type="checkbox" id={'ap'+item._id} />
                                            </div>
                                    )})}
                                </div>
                                    {!this.state.isValidCode && <div className="srv-validation-message" style={{ color: 'red',width:'100%',testAlign:'center',fontWeight: 900,letterSpacing: '0.8px' }}> {this.state.discount.filter(_ => _._id === this.state.userForApprove?.appliedDiscountCode?._id)[0]?.couponCode} has expired.</div>}
                                <h3 className="message_text ">Do you want to approve?</h3>
                                <div className="field_row text_center">
                                    <button onClick={(e) => this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'sio' ? this.UnApproveYes(e,'No') : this.CloseModal()}>NO</button>
                                    <button disabled={this.state.isPendingApproval || !this.state.isValidCode} className="active" onClick={this.ApproveYes}>YES {this.state.isPendingApproval &&
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    }</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* For UnApproval */}
                    <div className={`user_popup ${this.state.checkUnApprove ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_pass_popup unaprrove_pass_popup bg_white">
                            <div className="approve_popup_header relative text_center">
                                <span className="close_popup" onClick={this.CloseModal}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                    </svg>
                                </span>
                            </div>
                            <div className="pricing_row d_flex d_flex_align_center d_flex_justify_spacebt">
                                <h3 className="title">{this.state.displayPass && this.state.displayPass.name}</h3>
                                <h2 className="price">${this.state.displayPass && this.state.displayPass.discountPrice || this.state?.displayPass?.price}</h2>
                            </div>
                            <div className="content">
                                <div className="d_flex d_flex_justify_center complist_approve">
                                </div>
                                <p className="mt_10">User will not able to purchase this pass/package after unapproval if it is soldout.</p>
                                <h3 className="message_text ">Do you want to Unapprove?</h3>
                                <div className="field_row text_center">
                                    <button onClick={this.CloseModal}>NO</button>
                                    <button disabled={this.state.isPendingApproval} className="active" onClick={(e) => this.UnApproveYes(e, 'Yes')}>YES {this.state.isPendingApproval &&
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    }</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* For CSV upload successfully */}
                    <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* For CSV upload successfully */}
                    <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* For Create / Update SIO User */}
                    {this.state.createSIOuser ? <SIOuserModal ref='sioUser' defaultEmail={this.state.defaultEmail} roleWise={this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role} createuser={this.state.createSIOuser} CloseModal={this.CloseModal} /> : ''}


                    {/* For Create / Update PRESS User */}
                    {this.state.createPressuser ? <PressuserModal ref='pressUser' defaultEmail={this.state.defaultEmail} roleWise={this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role} createuser={this.state.createPressuser} CloseModal={this.CloseModal} /> : ''}


                    {/* For Create / Update GUEST User */}
                    {this.state.createCircleuser ? <CreateCircleuser ref='circleUser' defaultEmail={this.state.defaultEmail} roleWise={this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role} createuser={this.state.createCircleuser} CloseModal={this.CloseModal} membershipLevel={this.state.membershipLevel} /> : ''}
                    {
                        this.state.messageModal ?
                            <ModalMessage messageModal={this.state.messageModal} email="pinaki@sundance.org" ClosemessageModal={this.ClosemessageModal} /> : ''
                    }

                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                            ""
                        )}

                    {this.state.errorPopup ?
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                        />
                        : ''
                    }
                    {
                        this.state.membership ? <ManageMembershipModel CloseModal={this.CloseModal} clickUserMembership={this.state.clickUserMembership} /> : ""
                    }


                    {/* For Create / Update GENERAL User */}
                    {this.state.createGeneraluser ? <CreateGeneraluser ref='generalUser' createuser={this.state.createGeneraluser} CloseModal={this.CloseModal} roleWise={this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role}/> : ''}

                    {/* For Search User  */}
                    {this.state.searchUser ? <SearchUserModal CloseModal={this.CloseModal} CreateNewUser={this.CreateNewUser} SelectUser={this.SelectUser} /> : ''}


                    {this.state.messageModal ? <ModalMessage messageModal={this.state.messageModal} email="pinaki@sundance.org" ClosemessageModal={this.ClosemessageModal} /> : ''}

                    {
                        this.state.membership ? <ManageMembershipModel CloseModal={this.CloseModal} clickUserMembership={this.state.clickUserMembership} /> : ""
                    }
                </div>
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}

                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                {this.state.uploadCSVModal ? <CsvUploadModal CloseModal={this.CloseModal} totalAddedRecord={this.state.totalAddedRecord} totalSkippedRecord={this.state.totalSkippedRecord} skippedUser={this.state.skippedUser} message={this.state.message} totalUpdatedRecord={this.state.totalUpdatedRecord } /> : ''}

                {/* </div> */}
                {this.state.loaderFlag && <Loader />}

                {this.state.errorPopup && <ErrorPopUp errorMsg={this.state.errorMsg} errorMsgPopup={this.errorMsgPopup} />}

                {/* Purchase Receipet Modal*/}

                {
                    this.state.purchasereceipt ? <ReceiptModal CloseModal={this.CloseModal} purchaseList={this.state.purchaseList} role={this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role} onRefresh={() => this.purchaseReceipt(this.state.currentEventiveId)} /> : ''
                }

                {/* Device ID popup */}
                {
                    this.state.deviceModel ?
                        <div className='user_popup active'>
                            <span className="popup_overlay" onClick={this.props.errorMsgPopup}></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                                <div className="approve_popup_header text_center relative">
                                    <h3 className="mb_10">Current Device ID for {}</h3>
                                    <p className="mb_25">{moment(this.state.date).format("MM/DD/YYYY")}</p>
                                    <h2 className="error mb_25">{this.state.deviceId ? this.state.deviceId : 'Currently no OTT device has been registered'}</h2>
                                </div>
                                <div className="content">
                                    <div className="field_row text_center">
                                        <button className="small_btn" onClick={this.closedeviceModel}>CANCEL</button>
                                        <button className="small_btn active" onClick={(e) => this.handelDeviceremove(this.state.currentUserID)}>REMOVE ID</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ""}
                {this.state.syncMessageModal.flag && (
                    <div className={`user_popup active`}>
                        <span className="popup_overlay"></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                {this.state.syncMessageModal.message}
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseSyncMessageModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* User History & Information Modal */}
                {this.state.userHistoryModal && this.state.selectedHistoryUser && (() => {
                    const u = this.state.selectedHistoryUser;
                    return (
                        <div className="user_popup active">
                            <span className="popup_overlay" onClick={this.closeUserHistoryModal}></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup user_history_popup bg_white">
                                <div className="approve_popup_header relative">
                                    <p>User History &amp; Information</p>
                                    <span className="close_popup" onClick={this.closeUserHistoryModal}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="#FFFFFF" />
                                        </svg>
                                    </span>
                                </div>
                                <div className="content">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Sundance ID</td>
                                                <td className="uh_break">{u._id || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Eventive ID</td>
                                                <td>{u.eventiveId || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Location</td>
                                                <td>{u?.loginLocation && u.loginLocation?.city +' , ' + u.loginLocation?.state + ' , ' + u.loginLocation?.country || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Logged On</td>
                                                <td>{u.lastLogin ? moment(u.lastLogin).tz('US/Mountain').format('MM/DD/YYYY h:mm A') + ' MT' : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Password Changed At (MT)</td>
                                                <td>{u.lastForgotPassword ? moment(u.lastForgotPassword).tz('US/Mountain').format('MM/DD/YYYY h:mm A') + ' MT' : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Logged In Device / Browser</td>
                                                <td className="uh_break">{u.deviceType || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>User Agent</td>
                                                <td className="uh_break">{u.userAgent || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>IP Address</td>
                                                <td className="uh_break">{u.userIP || '-'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </React.Fragment >
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard)
